import { getUserRole } from '../../userLocalDetails';
import { isNullOrEmpty } from '../../utils/arrays';

export const isTeacherWithoutClass = (localClasses, role = null) => {
  const userRole = role || getUserRole();
  return userRole && (String(userRole).toUpperCase() === 'TEACHER') && isNullOrEmpty(localClasses);
};


export const isTeacher = (role = null) => {
  const userRole = role || getUserRole();
  return userRole && (String(userRole).toUpperCase() === 'TEACHER');
};

export const studentSubmissionTitleFunc = (breadcrumbs) => {
  return breadcrumbs && breadcrumbs[1] === 'CLOSED'
    ? 'Closed Tasks'
    : 'Tasks';
};
